import { Button } from '@mantine/core';
import { variants, Modal } from '@uag/react-core';
import { Trans, useTranslation } from 'react-i18next';
import { create, InstanceProps } from 'react-modal-promise';

type RemarkModalProps = {
    companyName?: string;
} & InstanceProps<string>;

const HideRequestModal = ({ companyName, isOpen, onResolve, onReject }: RemarkModalProps) => {
    const { t } = useTranslation();

    const submit = () => onResolve();
    const reject = () => onReject();

    return (
        <Modal opened={isOpen} size="lg" title={t('hideRequestQuestion')} onAbort={reject} onClose={reject}>
            <div className="text-text-ultra-light text-base">
                <Trans components={{ strong: <strong /> }} i18nKey="hideRequestMessage" values={{ companyName }} />
            </div>
            <Modal.Footer>
                <Button className="modal-action" variant={variants.button.secondary} onClick={reject}>
                    {t('cancel')}
                </Button>
                <Button className="modal-action" onClick={submit}>
                    {t('hideRequest')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export const openHideRequestModal = create(HideRequestModal);
